// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ServiciosRouteImport } from './routes/servicios'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PaquetesRouteImport } from './routes/paquetes'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CuentaRouteImport } from './routes/cuenta'
import { Route as ComoFuncionaRouteImport } from './routes/como-funciona'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LegalServiceAgreementRouteImport } from './routes/legal.service-agreement'
import { Route as LegalLimitedAuthorizationRouteImport } from './routes/legal.limited-authorization'
import { Route as LegalElectronicSignatureConsentRouteImport } from './routes/legal.electronic-signature-consent'
import { Route as IntakeTokenRouteImport } from './routes/intake.$token'
import { Route as GraciasTokenRouteImport } from './routes/gracias.$token'
import { Route as CuentaIndexRouteImport } from './routes/cuenta.index'
import { Route as CuentaResetPasswordRouteImport } from './routes/cuenta.reset-password'
import { Route as CuentaRegistroRouteImport } from './routes/cuenta.registro'
import { Route as CuentaRecuperarRouteImport } from './routes/cuenta.recuperar'
import { Route as CuentaLoginRouteImport } from './routes/cuenta.login'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminServiciosRouteImport } from './routes/admin.servicios'
import { Route as AdminPaquetesRouteImport } from './routes/admin.paquetes'
import { Route as AdminIntakesRouteImport } from './routes/admin.intakes'
import { Route as AdminFaqRouteImport } from './routes/admin.faq'
import { Route as CuentaPedidosIdRouteImport } from './routes/cuenta.pedidos.$id'
import { Route as AdminPedidosIndexRouteImport } from './routes/admin.pedidos.index'
import { Route as AdminClientesIndexRouteImport } from './routes/admin.clientes.index'
import { Route as AdminPedidosIdRouteImport } from './routes/admin.pedidos.$id'
import { Route as AdminFormulariosIdRouteImport } from './routes/admin.formularios.$id'
import { Route as AdminClientesIdRouteImport } from './routes/admin.clientes.$id'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ServiciosRoute = ServiciosRouteImport.update({
            id: '/servicios',path: '/servicios',getParentRoute: () => rootRouteImport
          })
const RefundPolicyRoute = RefundPolicyRouteImport.update({
            id: '/refund-policy',path: '/refund-policy',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PaquetesRoute = PaquetesRouteImport.update({
            id: '/paquetes',path: '/paquetes',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const CuentaRoute = CuentaRouteImport.update({
            id: '/cuenta',path: '/cuenta',getParentRoute: () => rootRouteImport
          })
const ComoFuncionaRoute = ComoFuncionaRouteImport.update({
            id: '/como-funciona',path: '/como-funciona',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LegalServiceAgreementRoute = LegalServiceAgreementRouteImport.update({
            id: '/legal/service-agreement',path: '/legal/service-agreement',getParentRoute: () => rootRouteImport
          })
const LegalLimitedAuthorizationRoute = LegalLimitedAuthorizationRouteImport.update({
            id: '/legal/limited-authorization',path: '/legal/limited-authorization',getParentRoute: () => rootRouteImport
          })
const LegalElectronicSignatureConsentRoute = LegalElectronicSignatureConsentRouteImport.update({
            id: '/legal/electronic-signature-consent',path: '/legal/electronic-signature-consent',getParentRoute: () => rootRouteImport
          })
const IntakeTokenRoute = IntakeTokenRouteImport.update({
            id: '/intake/$token',path: '/intake/$token',getParentRoute: () => rootRouteImport
          })
const GraciasTokenRoute = GraciasTokenRouteImport.update({
            id: '/gracias/$token',path: '/gracias/$token',getParentRoute: () => rootRouteImport
          })
const CuentaIndexRoute = CuentaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CuentaRoute
          })
const CuentaResetPasswordRoute = CuentaResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => CuentaRoute
          })
const CuentaRegistroRoute = CuentaRegistroRouteImport.update({
            id: '/registro',path: '/registro',getParentRoute: () => CuentaRoute
          })
const CuentaRecuperarRoute = CuentaRecuperarRouteImport.update({
            id: '/recuperar',path: '/recuperar',getParentRoute: () => CuentaRoute
          })
const CuentaLoginRoute = CuentaLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => CuentaRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminServiciosRoute = AdminServiciosRouteImport.update({
            id: '/servicios',path: '/servicios',getParentRoute: () => AdminRoute
          })
const AdminPaquetesRoute = AdminPaquetesRouteImport.update({
            id: '/paquetes',path: '/paquetes',getParentRoute: () => AdminRoute
          })
const AdminIntakesRoute = AdminIntakesRouteImport.update({
            id: '/intakes',path: '/intakes',getParentRoute: () => AdminRoute
          })
const AdminFaqRoute = AdminFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => AdminRoute
          })
const CuentaPedidosIdRoute = CuentaPedidosIdRouteImport.update({
            id: '/pedidos/$id',path: '/pedidos/$id',getParentRoute: () => CuentaRoute
          })
const AdminPedidosIndexRoute = AdminPedidosIndexRouteImport.update({
            id: '/pedidos/',path: '/pedidos/',getParentRoute: () => AdminRoute
          })
const AdminClientesIndexRoute = AdminClientesIndexRouteImport.update({
            id: '/clientes/',path: '/clientes/',getParentRoute: () => AdminRoute
          })
const AdminPedidosIdRoute = AdminPedidosIdRouteImport.update({
            id: '/pedidos/$id',path: '/pedidos/$id',getParentRoute: () => AdminRoute
          })
const AdminFormulariosIdRoute = AdminFormulariosIdRouteImport.update({
            id: '/formularios/$id',path: '/formularios/$id',getParentRoute: () => AdminRoute
          })
const AdminClientesIdRoute = AdminClientesIdRouteImport.update({
            id: '/clientes/$id',path: '/clientes/$id',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminFaqRoute: AdminFaqRoute,AdminIntakesRoute: AdminIntakesRoute,AdminPaquetesRoute: AdminPaquetesRoute,AdminServiciosRoute: AdminServiciosRoute,AdminSettingsRoute: AdminSettingsRoute,AdminIndexRoute: AdminIndexRoute,AdminClientesIdRoute: AdminClientesIdRoute,AdminFormulariosIdRoute: AdminFormulariosIdRoute,AdminPedidosIdRoute: AdminPedidosIdRoute,AdminClientesIndexRoute: AdminClientesIndexRoute,AdminPedidosIndexRoute: AdminPedidosIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const CuentaRouteChildren = {
  CuentaLoginRoute: CuentaLoginRoute,CuentaRecuperarRoute: CuentaRecuperarRoute,CuentaRegistroRoute: CuentaRegistroRoute,CuentaResetPasswordRoute: CuentaResetPasswordRoute,CuentaIndexRoute: CuentaIndexRoute,CuentaPedidosIdRoute: CuentaPedidosIdRoute
}

const CuentaRouteWithChildren = CuentaRoute._addFileChildren(CuentaRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,CheckoutRoute: CheckoutRoute,ComoFuncionaRoute: ComoFuncionaRoute,CuentaRoute: CuentaRouteWithChildren,FaqRoute: FaqRoute,PaquetesRoute: PaquetesRoute,PrivacyRoute: PrivacyRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RefundRoute: RefundRoute,RefundPolicyRoute: RefundPolicyRoute,ServiciosRoute: ServiciosRoute,TermsRoute: TermsRoute,GraciasTokenRoute: GraciasTokenRoute,IntakeTokenRoute: IntakeTokenRoute,LegalElectronicSignatureConsentRoute: LegalElectronicSignatureConsentRoute,LegalLimitedAuthorizationRoute: LegalLimitedAuthorizationRoute,LegalServiceAgreementRoute: LegalServiceAgreementRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)